import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { transparentize } from 'polished';

export const Container = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  ${({ theme }) => css`
    background-color: ${transparentize(
      0.8,
      theme?.colors?.black?.main || 'black'
    )};
  `};
`;
